import * as ConstantRouter from '@/constant/router';
import * as ConstantLabel from '@/constant/label';
import loadable from '@/utils/loadable';

const route = {
  path: 'broadcasts/:id',
  name: ConstantRouter.BROADCAST_DETAIL,
  component: loadable(
    () => import(/* webpackChunkName: "broadcasts-detail" */ '@/pages/broadcasts/detail/index.vue'),
  ),
  redirect: { name: ConstantRouter.BROADCAST_DESTINATIONS },
  children: [
    {
      path: 'sources',
      name: ConstantRouter.BROADCAST_SOURCES,
      meta: {
        name: ConstantLabel.BROADCAST_SOURCES,
      },
      component: loadable(
        () =>
          import(
            /* webpackChunkName: "broadcasts-detail-sources" */ '@/pages/broadcasts/detail/sources/index.vue'
          ),
      ),
    },
    {
      path: 'destinations',
      name: ConstantRouter.BROADCAST_DESTINATIONS,
      meta: {
        name: ConstantLabel.BROADCAST_DESTINATIONS,
      },
      component: loadable(
        () =>
          import(
            /* webpackChunkName: "broadcasts-detail-destinations" */ '@/pages/broadcasts/detail/destinations/index.vue'
          ),
      ),
    },
    {
      path: 'diagnostics',
      name: ConstantRouter.BROADCAST_DIAGNOSTICS,
      meta: {
        name: ConstantLabel.BROADCAST_DIAGNOSTICS,
      },
      component: loadable(
        () =>
          import(
            /* webpackChunkName: "broadcasts-detail-diagnostics" */ '@/pages/broadcasts/detail/diagnostics/index.vue'
          ),
      ),
    },
    {
      path: 'analytics',
      name: ConstantRouter.BROADCAST_ANALYTICS,
      meta: {
        name: ConstantLabel.BROADCAST_ANALYTICS,
      },
      component: loadable(
        () =>
          import(
            /* webpackChunkName: "broadcasts-detail-analytics" */ '@/pages/broadcasts/detail/analytics/index.vue'
          ),
      ),
    },
    {
      path: 'documents',
      name: ConstantRouter.BROADCAST_DOCUMENTS,
      meta: {
        name: ConstantLabel.BROADCAST_DOCUMENTS,
      },
      component: loadable(
        () =>
          import(
            /* webpackChunkName: "broadcasts-detail-documents" */ '@/pages/broadcasts/detail/documents/index.vue'
          ),
      ),
    },
    {
      path: 'chat',
      name: ConstantRouter.BROADCAST_CHAT,
      meta: {
        name: ConstantLabel.BROADCAST_CHAT,
      },
      component: loadable(
        () =>
          import(
            /* webpackChunkName: "broadcasts-detail-chat" */ '@/pages/broadcasts/detail/chat/index.vue'
          ),
      ),
      redirect: { name: ConstantRouter.BROADCAST_CHAT_COMMENT },
      children: [
        {
          path: 'comment',
          name: ConstantRouter.BROADCAST_CHAT_COMMENT,
          meta: {
            name: ConstantLabel.BROADCAST_CHAT_COMMENT,
          },
          component: loadable(
            () =>
              import(
                /* webpackChunkName: "broadcasts-detail-chat-comment" */ '@/pages/broadcasts/detail/chat/comment/index.vue'
              ),
          ),
        },
        {
          path: 'hidden',
          name: ConstantRouter.BROADCAST_CHAT_HIDDEN,
          meta: {
            name: ConstantLabel.BROADCAST_CHAT_HIDDEN,
          },
          component: loadable(
            () =>
              import(
                /* webpackChunkName: "broadcasts-detail-chat-hidden" */ '@/pages/broadcasts/detail/chat/hidden/index.vue'
              ),
          ),
        },
      ],
    },
    {
      path: 'report',
      name: ConstantRouter.BROADCAST_REPORT,
      meta: {
        name: ConstantLabel.BROADCAST_REPORT,
      },
      redirect: { name: ConstantRouter.BROADCAST_REPORT_LIVE_DATA },
      component: loadable(
        () =>
          import(
            /* webpackChunkName: "broadcasts-detail-report" */ '@/pages/broadcasts/detail/report/index.vue'
          ),
      ),
      children: [
        {
          path: 'live-data',
          name: ConstantRouter.BROADCAST_REPORT_LIVE_DATA,
          meta: {
            name: ConstantLabel.BROADCAST_REPORT_LIVE_DATA,
          },
          component: loadable(
            () =>
              import(
                /* webpackChunkName: "broadcasts-detail-report-live-data" */ '@/pages/broadcasts/detail/report/live-data/index.vue'
              ),
          ),
        },
        {
          path: 'view-data',
          name: ConstantRouter.BROADCAST_REPORT_VIEWERS_DATA,
          meta: {
            name: ConstantLabel.BROADCAST_REPORT_VIEWERS_DATA,
          },
          component: loadable(
            () =>
              import(
                /* webpackChunkName: "broadcasts-detail-report-view-data" */ '@/pages/broadcasts/detail/report/view-data/index.vue'
              ),
          ),
        },
        {
          path: 'stream-analytics',
          name: ConstantRouter.BROADCAST_REPORT_STREAM_DATA,
          meta: {
            name: ConstantLabel.BROADCAST_REPORT_STREAM_DATA,
          },
          component: loadable(
            () =>
              import(
                /* webpackChunkName: "broadcasts-detail-report-stream-analytics" */ '@/pages/broadcasts/detail/report/stream-analytics/index.vue'
              ),
          ),
        },
      ],
    },
    {
      path: 'trim',
      name: ConstantRouter.BROADCAST_TRIM,
      meta: {
        name: ConstantLabel.BROADCAST_TRIM,
      },
      component: loadable(
        () =>
          import(
            /* webpackChunkName: "broadcasts-detail-trim" */ '@/pages/broadcasts/detail/media/trim/index.vue'
          ),
      ),
    },
    {
      path: 'clips',
      name: ConstantRouter.BROADCAST_CLIPS,
      meta: {
        name: ConstantLabel.BROADCAST_CLIPS,
      },
      component: loadable(
        () =>
          import(
            /* webpackChunkName: "broadcasts-detail-highlight" */ '@/pages/broadcasts/detail/media/clips/index.vue'
          ),
      ),
    },
    {
      path: 'overlays',
      name: ConstantRouter.BROADCAST_OVERLAYS,
      meta: {
        name: ConstantLabel.BROADCAST_OVERLAYS,
      },
      component: loadable(
        () =>
          import(
            /* webpackChunkName: "broadcasts-detail-overlays" */ '@/pages/broadcasts/detail/overlays/index.vue'
          ),
      ),
    },
    {
      path: 'scoreboard',
      name: ConstantRouter.BROADCAST_SCOREBOARD,
      meta: {
        name: ConstantLabel.BROADCAST_SCOREBOARD,
      },
      component: loadable(
        () =>
          import(
            /* webpackChunkName: "broadcasts-detail-overlays" */ '@/pages/broadcasts/detail/scoreboard/index.vue'
          ),
      ),
    },
  ],
};

export default route;
